export default __webpack_public_path__ + "static/artifakt-element-black-7e554db5547c52e6a0f5c4959c04cc6c.ttf";